/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import './useConfig.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import 'vue';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';

function useCommonClassName() {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var sizeClassNames = {
    small: "".concat(classPrefix.value, "-size-s"),
    medium: "".concat(classPrefix.value, "-size-m"),
    large: "".concat(classPrefix.value, "-size-l"),
    "default": "",
    xs: "".concat(classPrefix.value, "-size-xs"),
    xl: "".concat(classPrefix.value, "-size-xl"),
    block: "".concat(classPrefix.value, "-size-full-width")
  };
  var statusClassNames = {
    loading: "".concat(classPrefix.value, "-is-loading"),
    loadMore: "".concat(classPrefix.value, "-is-load-more"),
    disabled: "".concat(classPrefix.value, "-is-disabled"),
    focused: "".concat(classPrefix.value, "-is-focused"),
    success: "".concat(classPrefix.value, "-is-success"),
    error: "".concat(classPrefix.value, "-is-error"),
    warning: "".concat(classPrefix.value, "-is-warning"),
    selected: "".concat(classPrefix.value, "-is-selected"),
    active: "".concat(classPrefix.value, "-is-active"),
    checked: "".concat(classPrefix.value, "-is-checked"),
    current: "".concat(classPrefix.value, "-is-current"),
    hidden: "".concat(classPrefix.value, "-is-hidden"),
    visible: "".concat(classPrefix.value, "-is-visible"),
    expanded: "".concat(classPrefix.value, "-is-expanded"),
    indeterminate: "".concat(classPrefix.value, "-is-indeterminate")
  };
  return {
    classPrefix: classPrefix,
    sizeClassNames: sizeClassNames,
    statusClassNames: statusClassNames,
    classNames: {
      size: sizeClassNames,
      status: statusClassNames
    }
  };
}

export { useCommonClassName as default };
//# sourceMappingURL=useCommonClassName.mjs.map
